import { render, staticRenderFns } from "./ClientContactModal.vue?vue&type=template&id=e89585d4"
import script from "./ClientContactModal.vue?vue&type=script&lang=js"
export * from "./ClientContactModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports